<template>
  <v-card class="my-3">
    <v-toolbar
      flat
      color="white">
      <v-toolbar-title>{{ $t('heading', {user: employeeName}) }}</v-toolbar-title>
      <v-spacer/>
    </v-toolbar>

    <v-data-table
      v-if="timesheets"
      :headers="headers"
      :items="timesheets"
      :loading="isTableLoading"
      :pagination.sync="pagination"
      :total-items="paginationTotal"
      :rows-per-page-items="[15]"
      class="">
      <template
        slot="items"
        slot-scope="props">
        <td
          class="pointer"
          @click="navigateByRole(props.item.id)">
          {{ parseDate(props.item.month) }}
        </td>
        <td class="text-xs-right td-fix">
          <v-btn
            icon
            @click="linkForTimesheet(props.item.id, props.item.month)">
            <v-icon>cloud_download</v-icon>
          </v-btn>

          <v-btn
            v-if="isCanDelete"
            :loading="deletingTimeSheetId === props.item.id ? isDeleting : false"
            :disabled="isDeleting"
            icon
            @click="deleteTimesheet(currentEmployee.company_id, props.item.id)">
            <v-icon color="error">delete</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>

    <v-card-actions>
      <v-spacer/>

      <timesheet-batch-one-employee-multiple-months
        v-if="timesheets"
        @updateOnSuccess="getPaginatedData"/>
    </v-card-actions>

  </v-card>
</template>

<script>
import TimesheetApi from '@/api/TimesheetApi'
import EmployeeInactivtyEntryDialog from '@/components/routes/employees/EmployeeInactivityEntryDialog'
import PaginationApi from '@/api/PaginationApi'
import TimesheetBatchOneEmployeeMultipleMonths
  from '@/components/routes/employees/TimesheetBatchOneEmployeeMultipleMonths'

import { mapGetters } from 'vuex'

export default {
  name: 'EmployeeTimesheetTable',
  components: {
    TimesheetBatchOneEmployeeMultipleMonths,
    EmployeeInactivtyEntryDialog
  },
  data () {
    return {
      isTableLoading: false,
      pagination: {},
      paginationTotal: 0,
      createEntryDialog: false,
      timesheets: [],
      isDeleting: false,
      deletingTimeSheetId: null,
      headers: [
        { text: this.$t('date'), sortable: false, width: '100%' },
        { text: '', sortable: false }
      ]
    }
  },
  computed: {
    ...mapGetters('employee', ['currentEmployee']),
    ...mapGetters('user', ['getUser']),
    query () {
      return [`employee_id=${this.currentEmployee.id}`]
    },

    url () {
      return 'company/timeSheets'
    },
    employeeName () {
      return `${this.currentEmployee.first_name} ${this.currentEmployee.last_name}`
    },
    isCanDelete () {
      const allowedRoles = [
        'company_manager'
      ]
      return allowedRoles.includes(this.getUser.role)
    }
  },
  methods: {
    async getPaginatedData () {
      this.isTableLoading = true
      try {
        const response = await PaginationApi.getPaginatedData(this.url, [`employee_id=${this.currentEmployee.id}`, `page=${this.pagination.page}`])
        this.paginationTotal = response.total
        this.timesheets = response.data
      } catch (e) {
        this.$notification(e)
      }
      this.isTableLoading = false
    },

    linkForTimesheet (timesheetId, timesheetMonth) {
      const fileName = `${timesheetMonth.split('-').reverse().join('-')}-${this.currentEmployee.id}-${this.currentEmployee.last_name}-${this.currentEmployee.first_name}`
      return TimesheetApi.downloadLinkForTimesheet(timesheetId, fileName)
    },

    parseDate (date) {
      return this.$moment(date, 'MM-YYYY').format('MMMM YYYY')
    },

    async deleteTimesheet (companyId, timeSheetId) {
      this.deletingTimeSheetId = timeSheetId
      this.isDeleting = true
      try {
        const response = await TimesheetApi.deleteTimesheet(timeSheetId)
        this.$notification(response)
        this.getPaginatedData()
      } catch (e) {
        this.$notification(e)
      }
      this.deletingTimeSheetId = null
      this.isDeleting = false
    },

    navigateByRole (timesheetId) {
      this.$router.push({ name: 'timesheet', params: { timesheetId } })
    }
  },
  watch: {
    pagination: {
      handler: `getPaginatedData`
    }
  },
  i18n: {
    messages: {
      en: {
        heading: 'Timesheet overview for {user}',
        date: 'Date'
      },
      tr: {
        heading: '{user} için zaman çizelgesi'
      },
      de: {
        heading: 'Stundenzettelübersicht für {user}',
        date: 'Datum'
      },
      ru: {
        heading: 'Обозор табеля для {user}',
        date: 'Дата'
      }
    }
  }
}
</script>

<style scoped>
  .td-fix {
    display: flex;
    flex-direction: row;
  }
</style>
